// extracted by mini-css-extract-plugin
export default {"page":"PageList_page__Cp8fA","row":"PageList_row__BCmfQ","col":"PageList_col__mlvjM","list":"PageList_list__qUGVO"};